module.exports = __webpack_public_path__ + "static/fonts/Roboto Slab Regular.d5d2a7ba.woff2";